<template>
  <el-container>
    <!-- 左边收索按钮 -->
    <el-aside>
      <el-input placeholder="关键字收索" v-model="keyWord"></el-input>
      <div class="left-active">
        <span>产品类别</span>
        <div>
          <el-button
            v-for="item in productTypeList"
            :key="item.id"
            @click="productClick(item.id)"
            :type="item.id == pType ? 'primary' : ''"
            >{{ item.tname }}</el-button
          >
        </div>
        <span>控制器型号</span>
        <div>
          <el-button
            v-for="(item, index) in controllerList"
            :type="item == controller ? 'primary' : ''"
            :key="index"
            @click="controllerClick(item)"
            >{{ item }}</el-button
          >
        </div>
        <span>产品型号</span>
        <div>
          <el-button
            v-for="(item, index) in productList"
            :type="item == product ? 'primary' : ''"
            :key="index"
            @click="serialClick(item)"
            >{{ item }}</el-button
          >
        </div>
        <span>文档类型</span>
        <div>
          <el-button
            v-for="item in docTypeList"
            :type="item.id == fileType ? 'primary' : ''"
            :key="item.id"
            @click="docTypeClick(item.id)"
            >{{ item.ftName }}</el-button
          >
        </div>
        <!-- <a href="https://epoch-image.oss-cn-hangzhou.aliyuncs.com/doc/pdf/STD13510灯光信号以及探测器分布图(1).pdf">aaa</a> -->
      </div>
    </el-aside>

    <el-main>
      <div>
        <div class="h-operation">
          <el-button v-if="!isLogin" type="success" @click="loginDialog = true"
            >登录</el-button
          >
          <el-button v-else type="success" @click="uploadPDF">上传</el-button>
        </div>
        <!-- 登录弹框 -->
        <el-dialog title="登录账号" :visible.sync="loginDialog" width="600px">
          <el-form :model="loginform">
            <el-form-item label="账号：" :label-width="formLabelWidth">
              <el-input
                class="form-input"
                v-model="loginform.loginName"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="密码：" :label-width="formLabelWidth">
              <el-input
                class="form-input"
                v-model="loginform.loginPassword"
                type="password"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="uploadDialog = false">取 消</el-button>
            <el-button type="primary" @click="loginUser">确 定</el-button>
          </div>
        </el-dialog>
        <!-- 上传弹框 -->
        <el-dialog title="上传文件" :visible.sync="uploadDialog" width="600px">
          <el-form :model="form">
            <el-form-item label="产品型号：" :label-width="formLabelWidth">
              <el-input
                class="form-input"
                v-model="form.product"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="文件类型：" :label-width="formLabelWidth">
              <el-select v-model="form.fileType" placeholder="请选择文件类型">
                <el-option
                  v-for="item in docTypeList"
                  :label="item.ftName"
                  :key="item.id"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="产品类型：" :label-width="formLabelWidth">
              <el-select v-model="form.pType" placeholder="请选择文件类型">
                <el-option
                  v-for="item in productTypeList"
                  :label="item.tname"
                  :key="item.id"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="控制器类型：" :label-width="formLabelWidth">
              <el-select v-model="form.controller" placeholder="请选择文件类型">
                <el-option
                  v-for="(item, index) in controllerList"
                  :label="item"
                  :key="index"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="文件：" :label-width="formLabelWidth">
              <!-- 上传 -->
              <el-upload
                class="upload-demo"
                action="https://"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                :on-change="changeFile"
                :auto-upload="false"
                :file-list="fileList"
                :limit="1"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  只能上传pdf/video文件
                </div>
              </el-upload>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="uploadDialog = false">取 消</el-button>
            <el-button type="primary" @click="uploadFile">确 定</el-button>
          </div>
        </el-dialog>
      </div>
      <div class="allpdf-box">
        <div v-if="docPdfList.length == 0" class="no-doc-box">
          <svg
            t="1599705710942"
            class="icon"
            viewBox="0 0 1567 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2273"
            width="81"
            height="81"
          >
            <path
              d="M156.662278 699.758173h21.097186A10.444152 10.444152 0 0 1 187.994733 710.202325c0 5.765172-4.490985 10.444152-10.235269 10.444152H156.662278v21.097186A10.444152 10.444152 0 0 1 146.218126 751.978932a10.277045 10.277045 0 0 1-10.444152-10.235269V720.646477H114.676787A10.444152 10.444152 0 0 1 104.441518 710.202325c0-5.765172 4.490985-10.444152 10.235269-10.444152H135.773974v-21.097187A10.444152 10.444152 0 0 1 146.218126 668.425717c5.765172 0 10.444152 4.490985 10.444152 10.235269v21.097187z m1378.628042-83.553215v-21.097186A10.277045 10.277045 0 0 0 1524.846168 584.872503a10.444152 10.444152 0 0 0-10.444152 10.235269v21.097186h-21.097186a10.277045 10.277045 0 0 0-10.235269 10.444152c0 5.598065 4.595427 10.444152 10.235269 10.444152h21.097186v21.097187c0 5.744284 4.67898 10.235269 10.444152 10.235268a10.444152 10.444152 0 0 0 10.444152-10.235268V637.093262h21.097187c5.744284 0 10.235269-4.67898 10.235268-10.444152a10.444152 10.444152 0 0 0-10.235268-10.444152H1535.29032zM776.460024 960.861969H250.596979A20.80475 20.80475 0 0 1 229.77134 939.973665c0-11.530344 9.462402-20.888304 20.825639-20.888303h94.728457A83.010119 83.010119 0 0 1 334.212859 877.413196v-605.96969A83.49055 83.49055 0 0 1 417.849627 187.994733H480.430984V167.001988A83.49055 83.49055 0 0 1 564.067752 83.553215h501.152182A83.448773 83.448773 0 0 1 1148.856702 167.001988v605.969689c0 15.185797-4.052331 29.410732-11.133466 41.672166h115.554096c11.551232 0 20.909192 9.274407 20.909192 20.888304 0 11.530344-9.295295 20.888304-20.888304 20.888304H1002.638576v20.992745c0 15.185797-4.052331 29.410732-11.133466 41.672166h11.196131c11.488567 0 20.825639 9.274407 20.825639 20.888303 0 11.530344-9.462402 20.888304-20.825639 20.888304h-109.893365c9.545955 16.000441 7.478013 36.972297-6.41271 50.863019a41.672166 41.672166 0 0 1-59.072122 0L776.460024 960.861969z m76.367638-41.776607h66.424806c22.977134 0 41.609501-18.59059 41.609501-41.881049V270.461756c0-22.559368-18.047494-40.690416-40.314426-40.690416H416.303892c-22.266932 0-40.314426 18.214601-40.314426 40.690416v606.742557c0 23.123352 18.799473 41.881049 41.588613 41.881049h317.084449l-10.736588-10.757477a41.693054 41.693054 0 0 1-10.861918-40.377091l-19.718558-19.739447A146.259902 146.259902 0 0 1 502.363703 627.693525a146.218126 146.218126 0 0 1 220.517822 190.981761l19.739447 19.739447a41.630389 41.630389 0 0 1 40.377091 10.841029L852.827662 919.085362zM1002.638576 814.643843h62.852906A41.797496 41.797496 0 0 0 1107.080095 772.867236V167.106429c0-23.14424-18.632367-41.776607-41.588613-41.776607H563.775316A41.797496 41.797496 0 0 0 522.207592 167.106429v20.888304h396.794216A83.448773 83.448773 0 0 1 1002.638576 271.443506V814.643843zM266.325872 46.998683h31.123572c8.773088 0 15.875111 6.955805 15.875111 15.666228 0 8.647758-7.102023 15.666228-15.875111 15.666228h-31.123572v31.123572c0 8.773088-6.955805 15.875111-15.666228 15.875111a15.770669 15.770669 0 0 1-15.666228-15.875111V78.331139H203.869844A15.728893 15.728893 0 0 1 187.994733 62.664911c0-8.647758 7.102023-15.666228 15.875111-15.666228h31.123572V15.875111c0-8.773088 6.955805-15.875111 15.666228-15.875111 8.647758 0 15.666228 7.102023 15.666228 15.875111v31.123572zM20.888304 939.973665c0-11.530344 9.462402-20.888304 20.825638-20.888303h125.455152c11.488567 0 20.825639 9.274407 20.825639 20.888303 0 11.530344-9.462402 20.888304-20.825639 20.888304H41.713942A20.80475 20.80475 0 0 1 20.888304 939.973665z m658.733544-135.021995a104.441518 104.441518 0 1 0-147.722083-147.722083 104.441518 104.441518 0 0 0 147.722083 147.722083zM459.542681 313.324555a20.888304 20.888304 0 0 1 20.867415-20.888304H710.202325a20.888304 20.888304 0 1 1 0 41.776608H480.430984A20.825639 20.825639 0 0 1 459.542681 313.324555z m0 104.441518c0-11.530344 9.295295-20.888304 20.742085-20.888303h334.505295c11.44679 0 20.742086 9.274407 20.742086 20.888303 0 11.530344-9.295295 20.888304-20.742086 20.888304H480.284766A20.762974 20.762974 0 0 1 459.542681 417.766073z m0 104.441519c0-11.530344 9.316183-20.888304 20.846527-20.888304h146.301679c11.509455 0 20.846527 9.274407 20.846527 20.888304 0 11.530344-9.316183 20.888304-20.846527 20.888303h-146.301679A20.80475 20.80475 0 0 1 459.542681 522.207592zM62.664911 396.87777a62.664911 62.664911 0 1 1 0-125.329822 62.664911 62.664911 0 0 1 0 125.329822z m0-31.332456a31.332456 31.332456 0 1 0 0-62.664911 31.332456 31.332456 0 0 0 0 62.664911zM1357.739739 271.547948a62.664911 62.664911 0 1 1 0-125.329822 62.664911 62.664911 0 0 1 0 125.329822z m0-31.332456a31.332456 31.332456 0 1 0 0-62.664911 31.332456 31.332456 0 0 0 0 62.664911z"
              fill="#8A96A3"
              p-id="2274"
            ></path>
          </svg>
          <p>暂无数据</p>
        </div>
        <div
          v-else
          class="pdf-item"
          v-for="(item, index) in docPdfList"
          :key="index"
          @click="getDocUrlAndShow(item.fileUrl)"
        >
          <svg
            t="1599698700134"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2783"
            width="81"
            height="81"
          >
            <path
              d="M145.6 0C100.8 0 64 36.8 64 81.6v860.8C64 987.2 100.8 1024 145.6 1024h732.8c44.8 0 81.6-36.8 81.6-81.6V324.8L657.6 0h-512z"
              fill="#8C181A"
              p-id="2784"
            ></path>
            <path
              d="M960 326.4v16H755.2s-100.8-20.8-97.6-107.2c0 0 3.2 91.2 96 91.2H960z"
              fill="#6B0D12"
              p-id="2785"
            ></path>
            <path
              d="M657.6 0v233.6c0 27.2 17.6 92.8 97.6 92.8H960L657.6 0z"
              fill="#FFFFFF"
              p-id="2786"
            ></path>
            <path
              d="M302.4 784h-52.8v65.6c0 6.4-4.8 11.2-12.8 11.2-6.4 0-11.2-4.8-11.2-11.2V686.4c0-9.6 8-17.6 17.6-17.6h59.2c38.4 0 60.8 27.2 60.8 57.6 0 32-22.4 57.6-60.8 57.6z m-1.6-94.4h-51.2v73.6h51.2c22.4 0 38.4-14.4 38.4-36.8s-16-36.8-38.4-36.8z m166.4 171.2h-48c-9.6 0-17.6-8-17.6-17.6v-156.8c0-9.6 8-17.6 17.6-17.6h48c59.2 0 99.2 41.6 99.2 96s-38.4 96-99.2 96z m0-171.2h-41.6v148.8h41.6c46.4 0 73.6-33.6 73.6-75.2 1.6-40-25.6-73.6-73.6-73.6z m260.8 0h-92.8V752h91.2c6.4 0 9.6 4.8 9.6 11.2s-4.8 9.6-9.6 9.6h-91.2v76.8c0 6.4-4.8 11.2-12.8 11.2-6.4 0-11.2-4.8-11.2-11.2V686.4c0-9.6 8-17.6 17.6-17.6h99.2c6.4 0 9.6 4.8 9.6 11.2 1.6 4.8-3.2 9.6-9.6 9.6z"
              fill="#FFFFFF"
              p-id="2787"
            ></path>
          </svg>
          <p class="pdf-title">
            {{ item.fileName }}
          </p>
        </div>
        <!-- 文档展示弹出框 -->
        <el-drawer
          :visible.sync="showDoc"
          direction="rtl"
          :size="draSize"
          :show-close="showCloce"
        >
          <div id="docBox"></div>
        </el-drawer>
      </div>
    </el-main>
  </el-container>
</template>
<script>
import PDFObject from "pdfobject";
// import pdf from "vue-pdf";
import { mapGetters } from "vuex";
export default {
  // components: { pdf },
  data() {
    return {
      isLogin: false,
      productTypeList: [],
      controllerList: [],
      productList: [],
      docTypeList: [],
      product: "",
      controller: "",
      pType: "",
      fileType: "",
      keyWord: "",
      docPdfList: [],
      // 上传
      uploadDialog: false,
      formLabelWidth: "120px",
      fileList: [],
      loginDialog: false,
      loginform: {
        loginName: "",
        loginPassword: ""
      },
      form: {
        fileType: "",
        product: "",
        pType: "",
        controller: ""
      },
      DocUrl: "",
      draSize: "60%",
      showCloce: true,
      showDoc: false,
      timer: "",
      windowScreen: document.body.clientWidth
    };
  },
  created() {
    // let _this = this
    // window.onresize = function () {
    //   _this.windowScreen = document.body.clientWidth
    // }
    this.getProductType();
    this.getControllerList();
    this.getDocTypeList();
    this.getProductList();
    // 获取url的参数
    if (this.$route.query.t) {
      this.controller = this.$route.query.t;
      this.getDocFileList();
    } else {
      this.getDocFileList();
    }
    if (this.userlogin_doc.uid != "") {
      this.isLogin = true;
    }
  },
  mounted() {},
  computed: {
    ...mapGetters(["userlogin_doc"])
  },
  watch: {
    DocUrl: function(val) {
      this.$nextTick(() => {
        PDFObject.embed(val, "#docBox");
      });
    },
    keyWord: function(val) {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getDocFileList();
        clearInterval(this.timer);
      }, 500);
    }
  },
  methods: {
    queryAll() {
      this.getProductType();
      this.getControllerList();
      this.getDocTypeList();
      this.getProductList();
      this.getDocFileList();
    },
    /*
     **  @description 查询产品类型
     **  @param {}
     **  @return
     **  @author shipingan
     */
    getProductType() {
      let url = "/dapi/doc/getProductType?types=1";
      this.$axios.get(url).then(res => {
        let data = res.data;
        if (data.status == 0) {
          this.productTypeList = data.data;
        } else {
          this.$message.error("服务器异常");
        }
      });
    },
    /*
     **  @description 控制器类别
     **  @param {}
     **  @return
     **  @author shipingan
     */
    getControllerList() {
      let url = "/dapi/doc/getProductType?types=4";
      this.$axios.get(url).then(res => {
        let data = res.data;
        if (data.status == 0) {
          this.controllerList = data.data;
        } else {
          this.$message.error("服务器异常");
        }
      });
    },
    /*
     **  @description 查询文档类型
     **  @param {}
     **  @return
     **  @author shipingan
     */
    getDocTypeList() {
      let url = "/dapi/doc/getFileTypes";
      this.$axios.get(url).then(res => {
        let data = res.data;
        if (data.status == 0) {
          this.docTypeList = data.data;
        } else {
          this.$message.error("服务器异常");
        }
      });
    },
    /*
     **  @description 获取产品型号
     **  @param {}
     **  @return
     **  @author shipingan
     */
    getProductList() {
      let url = "/dapi/doc/getProductByType?pType=&controller=";
      this.$axios.get(url).then(res => {
        let data = res.data;
        if (data.status == 0) {
          this.productList = data.data;
        } else {
          this.$message.error("服务器异常");
        }
      });
    },
    /*
     **  @description 点击
     **  @param {}
     **  @return
     **  @author shipingan
     */
    productClick(id) {
      if (this.pType == id) {
        this.pType = "";
        this.getDocFileList();
        return;
      }
      this.pType = id;
      this.getDocFileList();
    },
    controllerClick(controller) {
      if (this.controller == controller) {
        this.controller = "";
        this.getDocFileList();
        return;
      }
      this.controller = controller;
      this.getDocFileList();
    },
    serialClick(id) {
      if (this.product == id) {
        this.product = "";
        this.getDocFileList();
        return;
      }
      this.product = id;
      this.getDocFileList();
    },
    docTypeClick(id) {
      if (this.fileType == id) {
        this.fileType = "";
        this.getDocFileList();
        return;
      }
      this.fileType = id;
      this.getDocFileList();
    },
    /*
     **  @description 查询文件
     **  @param {}
     **  @return
     **  @author shipingan
     */
    queryKwords() {},
    getDocFileList() {
      let params = {
        product: this.product,
        pType: this.pType,
        fileType: this.fileType,
        controller: this.controller,
        keyWord: this.keyWord
      };
      this.$axios
        .get("/dapi/doc/queryFile", {
          params: params
        })
        .then(res => {
          let data = res.data;
          if (data.status == 0) {
            this.docPdfList = data.data;
          } else {
            this.docPdfList = [];
          }
        });
    },
    /*
     **  @description 查看文件
     **  @param {}
     **  @return
     **  @author shipingan
     */
    getDocUrlAndShow(DocUrl) {
      if (PDFObject.supportsPDFs) {
        this.showDoc = true;
        this.DocUrl = DocUrl;
      } else {
        this.$message.error("您的手机不支持PDFobject,请选择其他方式预览或下载");
        let a = document.createElement("a");
        a.href = DocUrl;
        a.click();
      }
      if (this.windowScreen <= 800) {
        this.draSize = "100%";
        this.DocUrl = DocUrl;
        this.showCloce = true;
      } else {
        this.draSize = "60%";
        this.showCloce = false;
      }
    },
    /*
     **  @description 文件上传
     **  @param {}
     **  @return
     **  @author shipingan
     */
    uploadPDF() {
      this.uploadDialog = true;
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    changeFile(file, fileList) {
      this.fileList = fileList;
    },
    uploadFile() {
      if (
        this.form.fileType == "" ||
        this.form.product == "" ||
        this.form.pType == "" ||
        this.form.controller == ""
      ) {
        this.$message.error("请填写完整参数");
        return;
      }

      let file = new FormData();
      file.append("file", this.fileList[0].raw);
      file.append("fileType", this.form.fileType);
      file.append("product", this.form.product);
      file.append("pType", this.form.pType);
      file.append("controller", this.form.controller);
      let url = "/dapi/doc/upload";
      this.$axios.post(url, file).then(res => {
        console.log(res);
        let data = res.data;
        if (data.status == 0) {
          this.$message({
            type: "success",
            message: "上传成功"
          });
          this.uploadDialog = false;
          this.queryAll();
        }
      });
    },
    /*
     **  @description 登录账号
     **  @param {}
     **  @return
     **  @author shipingan
     */
    loginUser() {
      this.$axios
        .post("/dapi/u/webLogin", this.$qs.stringify(this.loginform))
        .then(res => {
          console.log(res);
          let data = res.data;
          if (data.status == 200) {
            this.$store.dispatch("setUserDataDoc", data.data);
            this.isLogin = true;
            this.loginDialog = false;
            this.$message({
              type: "success",
              message: "登录成功"
            });
          }
        });
    }
  }
};
</script>
<style lang="less" scoped>
@box-shadow: 0 0 10px #ccc;
.el-container {
  height: 100%;
  .el-aside {
    box-shadow: @box-shadow;
    padding: 10px;
    .left-active {
      margin-top: 10px;
      height: calc(100% - 50px);
      display: flex;
      flex-direction: column;
      span {
        text-align: left;
        padding-left: 5px;
        font-family: cursive;
        font-weight: 600;
      }
      div {
        margin: 5px 0;
        box-shadow: @box-shadow;
        display: flex;
        flex-wrap: wrap;
        padding: 5px;
        background-color: #dce1bf;
        border-radius: 5px;
        // 最大高度
        max-height: 30%;
        overflow: auto;
        .el-button {
          margin: 5px;
        }
      }
    }
  }
  .el-main {
    /deep/ .el-drawer__header {
      display: none;
    }
    #docBox {
      width: 100%;
      height: 100%;
    }
    .no-doc-box {
      padding: 20px;
      font-family: cursive;
    }
    .h-operation {
      text-align: right;
    }
    .form-input {
      width: 193px;
    }
    .allpdf-box {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      .pdf-item {
        padding: 20px 10px;
        width: 10%;
        min-width: 200px;
        margin: 10px 40px;
        box-shadow: @box-shadow;
        border-radius: 10px;
        cursor: pointer;
        .pdf-title {
          font-family: cursive;
        }
      }
    }
  }
}
@media screen and (max-width: 800px) {
  .el-aside {
    width: 220px !important;
  }
  /deep/ .el-drawer__header {
    display: block !important;
  }
}
</style>
